import { useMemo, useState } from 'react'
import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { historyUtils } from '@wartek-id/fe-toolbox'

import Share from 'app/CeritaPraktikPage/components/Share'
import CeritaPraktikDetail from 'app/CeritaPraktikPage/pages/Detail'
import { useSETrackEvent } from 'app/CeritaPraktikPage/hooks/useSETrackEvent'
import { TRACKER_QUERY_SOURCE_KEY } from 'app/CeritaPraktikPage/constants'

// TODO: add typing, infer the GSSP
const CeritaPraktikDetailPage = ({ id }: { id: string }) => {
  const [title, setTitle] = useState<string>('')

  return (
    <>
      <PageHeader title={title} />
      <CeritaPraktikDetail id={id} onPageLoaded={(title) => setTitle(title)} />
    </>
  )
}

type PageHeaderProps = {
  title?: string
}

const PageHeader = ({ title }: PageHeaderProps) => {
  const router = useRouter()

  const shareUrl = useMemo(() => {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    params.delete(TRACKER_QUERY_SOURCE_KEY)
    url.search = params.toString()

    return url.toString()
  }, [])

  const shareMessage: string = `Bapak/Ibu Guru, ada Ide Praktik "${title}" di platform Merdeka Mengajar. Silakan cek di tautan berikut:`

  const { SETrackClickBack, SETrackShare } = useSETrackEvent()

  return (
    <HeaderBar fixed borderless className="z-10">
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            arrow_back
          </Icon>
        }
        onClick={() => {
          SETrackClickBack(() => {
            historyUtils.backToApp(router.back)
          })
        }}
      />
      <HeaderBarRightAction>
        {!!title && (
          <Share
            title="Bagikan Ide Praktik"
            shareMessage={shareMessage}
            shareUrl={shareUrl}
            onShare={(funnel) =>
              SETrackShare({
                funnel: (funnel as string).toUpperCase(),
              })
            }
          />
        )}
      </HeaderBarRightAction>
    </HeaderBar>
  )
}

export const getServerSideProps = (ctx) => {
  const query = ctx.query

  if (
    process.env.NEXT_PUBLIC_CERITA_PRAKTIK_PAGE_ENABLED !== 'true' ||
    !query?.id
  ) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }

  return {
    props: {
      id: query?.id,
    },
  }
}

CeritaPraktikDetailPage.layoutOpts = {
  hasHeader: true,
  // Note: !h-full is a workaround to force the the container to be fully height according to its content
  className: '!h-full bg-gray-10 min-h-screen',
}

export default CeritaPraktikDetailPage
